import React, { lazy, Suspense } from "react";
import EditorShell from "views/components/Editor/EditorShell";
import useMobile from "views/components/Editor/mobile/useMobile";
import { MOBILE_EDITOR_ENABLED } from "lib/constants";
const EditorContainer = lazy(() => import("./EditorContainer"));

export const EditorContainerLazy = props => {
  const isMobileViewport = useMobile();
  const isMobile = MOBILE_EDITOR_ENABLED && isMobileViewport;

  return (
    /* EditorShell covers both boot gates: this Suspense fallback (editor
       chunk download) and EditorContainer's fetchDesign loading state — the
       same chrome stays on screen across the whole wait. */
    <Suspense fallback={<EditorShell isMobile={isMobile} />}>
      <EditorContainer {...props} isMobile={isMobile} />
    </Suspense>
  );
};
EditorContainerLazy.displayName = "EditorContainer";

export default EditorContainerLazy;
